<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>RENDERING</div>
				<h2 waHeading="l" waText>Type-Safe HTML, CSS, and JavaScript</h2>
				<p waBody="m" waColorText="quiet" waText>The entire web platform as Java types.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Complete HTML5 Element Library</h3>
							<p waBody="m" waColorText="quiet" waText>Every HTML5 element &mdash; Div, Span, Table, Form, Input &#40;22 typed variants&#41;, Select, Canvas, Video, Article, Section &mdash; is a typed Java class with CRTP fluent API. Child constraints are enforced at compile time.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Typed CSS Builder</h3>
							<p waBody="m" waColorText="quiet" waText>14 CSS sub-packages: backgrounds, borders, colours, fonts, margins, padding, displays, text, tables, lists, outline, height/width, measurement, and animatable properties &mdash; all as Java annotations and builders.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Dual-Mode Output</h3>
							<p waBody="m" waColorText="quiet" waText>toString&#40;true&#41; renders full HTML with all CSS/JS assets for hosted mode. toString&#40;&#41; renders JSON for AJAX responses. Same component tree, two formats.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Component Hierarchy</h3>
							<p waBody="m" waColorText="quiet" waText>11-layer CRTP chain from ComponentBase to Component &mdash; each layer adds capabilities: hierarchy, HTML, attributes, options, styles, themes, data-binding, dependencies, features, events. Zero runtime overhead.</p>
						</div>
					</wa-card>
				</div>
			</div>
		</div>
	</div>
</div>